import type { ThemeConfig } from 'antd';

/**
 * Тема Ant Design 5 — HKeeper
 * Светлый сайдбар, чистый контент, чёрно-белый акцент
 */
export const antdTheme: ThemeConfig = {
  token: {
    // Основные цвета
    colorPrimary: '#0a0a0a',
    colorSuccess: '#22c55e',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorInfo: '#3b82f6',

    // Фоны
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f5f7fa',
    colorBgElevated: '#ffffff',

    // Текст
    colorText: '#1a2332',
    colorTextSecondary: '#5a6b7f',
    colorTextTertiary: '#8896a6',

    // Borders
    colorBorder: '#e2e8f0',
    colorBorderSecondary: '#f1f4f8',

    // Радиусы
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 4,

    // Типографика
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 14,
    fontSizeHeading1: 28,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 16,

    // Тени
    boxShadow:
      '0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -2px rgba(0, 0, 0, 0.05)',
    boxShadowSecondary:
      '0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.04)',

    // Spacing
    controlHeight: 36,
    controlHeightLG: 44,
    controlHeightSM: 28,
  },
  components: {
    Layout: {
      siderBg: '#ffffff',
      headerBg: '#ffffff',
      bodyBg: '#f5f7fa',
    },
    Menu: {
      itemBg: '#ffffff',
      itemColor: '#5a6b7f',
      itemHoverBg: '#f5f5f5',
      itemHoverColor: '#0a0a0a',
      itemSelectedBg: '#f5f5f5',
      itemSelectedColor: '#0a0a0a',
      subMenuItemBg: '#ffffff',
      groupTitleColor: '#8896a6',
    },
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Table: {
      headerBg: '#f8fafc',
      headerColor: '#5a6b7f',
      rowHoverBg: '#f8fafc',
      borderColor: '#f1f4f8',
    },
    Card: {
      boxShadowTertiary:
        '0 1px 2px rgba(0, 0, 0, 0.05)',
    },
    Input: {
      activeBorderColor: '#0a0a0a',
      hoverBorderColor: '#0a0a0a',
    },
    DatePicker: {
      cellActiveWithRangeBg: '#f0f0f0',
      cellHoverBg: '#f5f5f5',
      cellRangeBorderColor: '#d9d9d9',
    },
    Select: {
      optionSelectedBg: '#f5f5f5',
      optionSelectedColor: '#0a0a0a',
      optionActiveBg: '#f0f0f0',
      optionSelectedFontWeight: 600,
    },
  },
};
